/* ============================================================
   SANCORD - Barra de progreso de envío gratis (carrito)
   - Umbral: 39,00 € (3900 en céntimos)
   - Se inyecta en el cart drawer y en la página de carrito
   - Se actualiza al abrir el carrito y tras añadir/cambiar
   Colores SANCORD: navy #1f3a5f + naranja #f28c28
   ============================================================ */
/* --- Override: banner de cookies compacto en móvil (no tapa el CTA) --- */
(function () {
  try {
    var st = document.createElement('style');
    st.textContent = '@media (max-width:749px){csm-cookie-consent,.csm-cookie-consent,#csm-cookie-consent{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;transform:none!important;max-width:100%!important;width:100%!important;max-height:42vh!important;overflow-y:auto!important;border-radius:14px 14px 0 0!important;box-shadow:0 -6px 24px rgba(0,0,0,.18)!important;}csm-cookie-consent *{max-width:100%!important;}}';
    document.head.appendChild(st);
  } catch (e) {}
})();

/* --- Override: franja "EN OFERTA" de la ficha en color de marca (antes verde/teal) --- */
(function () {
  try {
    var st = document.createElement('style');
    st.textContent = '.return-box{background-image:linear-gradient(45deg,#f7941d,#f28c28)!important;}'
      + '.sancord-badges{display:flex;flex-wrap:wrap;gap:8px;margin:14px 0;max-width:460px;}'
      + '.sancord-badges .sb-item{display:flex;align-items:center;gap:7px;background:#fff;border:1px solid #eef1f5;border-radius:10px;padding:8px 10px;flex:1 1 46%;min-width:130px;}'
      + '.sancord-badges .sb-ic{width:22px;height:22px;flex-shrink:0;color:#f28c28;}'
      + '.sancord-badges .sb-ic svg{width:100%;height:100%;}'
      + '.sancord-badges .sb-t{font-weight:700;font-size:12.5px;color:#1f3a5f;line-height:1.15;}';
    document.head.appendChild(st);
  } catch (e) {}
})();

/* --- Sustituir la imagen de garantías con errata ("PAGO SEURO") por una barra HTML correcta --- */
(function () {
  var IMG_ID = '3f81e44d-0a05-4c4a-9f7c-508ef682ebc8'; // imagen antigua con la errata
  function icon(p) { return '<span class="sb-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg></span>'; }
  function badgesHTML() {
    return '<div class="sancord-badges">'
      + '<div class="sb-item">' + icon('<rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>') + '<span class="sb-t">Envío GRATIS +39€</span></div>'
      + '<div class="sb-item">' + icon('<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>') + '<span class="sb-t">Entrega 24/48h</span></div>'
      + '<div class="sb-item">' + icon('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>') + '<span class="sb-t">Pago 100% seguro</span></div>'
      + '<div class="sb-item">' + icon('<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>') + '<span class="sb-t">Devolución 15 días</span></div>'
      + '<div class="sb-item">' + icon('<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/>') + '<span class="sb-t">Enviado desde España</span></div>'
      + '</div>';
  }
  function swap() {
    var img = document.querySelector('img[src*="' + IMG_ID + '"]');
    if (!img) return false;
    var block = img.closest('.main-product__block') || img.parentNode;
    if (block.dataset.sancordSwapped) return true;
    block.dataset.sancordSwapped = '1';
    var wrap = document.createElement('div');
    wrap.innerHTML = badgesHTML();
    block.innerHTML = '';
    block.appendChild(wrap.firstChild);
    return true;
  }
  document.addEventListener('DOMContentLoaded', swap);
  var tries = 0, iv = setInterval(function () { if (swap() || ++tries > 8) clearInterval(iv); }, 500);
})();

/* --- DESACTIVADO (27/07/2026, Cowork): barra de progreso de envío gratis inyectada por JS ---
   Motivo: duplicaba la barra ya renderizada de forma nativa vía Liquid en
   snippets/free-shipping-bar.liquid (usada en sections/cart-template.liquid
   y snippets/cart-drawer.liquid). Este script coincidía además con
   selectores genéricos (.m-cart__items, form[action$="/cart"]) presentes en
   la propia página /cart, por lo que se insertaba una segunda barra con
   texto distinto ("Te faltan X para el envío gratis") justo antes de la
   cabecera de la tabla de producto. La versión Liquid ya cubre carrito y
   cart drawer, así que este bloque queda eliminado en vez de simplemente
   oculto, para no arrastrar código muerto.
   Bloque original conservado en el historial de Shopify (versión anterior
   del tema) por si se necesita revertir. --- */

/* --- Frecuentemente comprado junto (ficha de producto) --- */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var ACCENT = '#f28c28', NAVY = '#1f3a5f';

  var st = document.createElement('style');
  st.textContent =
    '.sancord-fbt{border:1px solid #eef1f5;border-radius:14px;padding:16px;margin:18px 0;background:#fff;box-shadow:0 6px 18px rgba(20,40,70,.06);}'
    + '.sancord-fbt h3{font-size:16px;font-weight:800;color:' + NAVY + ';margin:0 0 4px;}'
    + '.sancord-fbt .fbt-sub{font-size:12.5px;color:#7a8698;margin:0 0 12px;}'
    + '.sancord-fbt .fbt-row{display:flex;align-items:center;gap:10px;padding:8px 0;border-top:1px solid #f1f4f8;}'
    + '.sancord-fbt .fbt-row:first-of-type{border-top:none;}'
    + '.sancord-fbt input[type=checkbox]{width:18px;height:18px;accent-color:' + ACCENT + ';flex-shrink:0;cursor:pointer;}'
    + '.sancord-fbt img{width:46px;height:46px;object-fit:contain;border-radius:8px;background:#f7f9fc;flex-shrink:0;}'
    + '.sancord-fbt .fbt-name{flex:1;min-width:0;font-size:13px;line-height:1.3;color:#33404f;}'
    + '.sancord-fbt .fbt-name a{color:inherit;text-decoration:none;}'
    + '.sancord-fbt .fbt-price{font-weight:700;color:' + NAVY + ';font-size:13px;white-space:nowrap;}'
    + '.sancord-fbt .fbt-foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:12px;flex-wrap:wrap;}'
    + '.sancord-fbt .fbt-total{font-size:14px;color:' + NAVY + ';}'
    + '.sancord-fbt .fbt-total b{font-size:18px;}'
    + '.sancord-fbt button{background:linear-gradient(135deg,#f7941d,' + ACCENT + ');color:#fff;border:none;font-weight:700;font-size:14px;text-transform:uppercase;padding:12px 20px;border-radius:10px;cursor:pointer;transition:transform .15s ease;}'
    + '.sancord-fbt button:hover{transform:translateY(-2px);}'
    + '.sancord-fbt button[disabled]{opacity:.5;cursor:default;transform:none;}';
  document.head.appendChild(st);

  function money(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function firstAvail(p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0]; return v; }
  function imgOf(p) { return p.featured_image || (p.images && p.images[0]) || ''; }

  var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
  var main = null, recs = [];

  fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) { main = p; return fetch('/recommendations/products.json?product_id=' + p.id + '&intent=complementary&limit=3', { headers: { Accept: 'application/json' } }); })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      recs = (d.products || []).slice(0, 3);
      if (recs.length > 0) return null;
      return fetch('/recommendations/products.json?product_id=' + main.id + '&intent=related&limit=3', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d2) { recs = (d2.products || []).slice(0, 3); });
    })
    .then(function () { if (main && recs.length) build(); })
    .catch(function () {});

  function build() {
    if (document.querySelector('.sancord-fbt')) return;
    var items = [main].concat(recs);
    var box = document.createElement('div');
    box.className = 'sancord-fbt';
    var rows = '';
    items.forEach(function (p, i) {
      var v = firstAvail(p);
      if (!v) return;
      rows += '<label class="fbt-row">'
        + '<input type="checkbox" data-vid="' + v.id + '" data-price="' + p.price + '" checked>'
        + '<img src="' + imgOf(p) + '" alt="">'
        + '<span class="fbt-name">' + (i === 0 ? '<b>Este producto:</b> ' : '') + '<a href="' + (p.url || '#') + '">' + p.title + '</a></span>'
        + '<span class="fbt-price">' + money(p.price) + '</span>'
        + '</label>';
    });
    box.innerHTML = '<h3>🛒 Frecuentemente comprado junto</h3>'
      + '<p class="fbt-sub">Llévalo con estos complementos y aprovecha el envío gratis a partir de 39€.</p>'
      + rows
      + '<div class="fbt-foot"><div class="fbt-total">Total: <b class="fbt-amount"></b></div>'
      + '<button type="button" class="fbt-add">Añadir seleccionados</button></div>';

    // Insertar tras el bloque de "Añadir al carrito"
    var atc = document.querySelector('.m-add-to-cart, .m-product-form__submit, [name="add"]');
    var anchor = atc ? (atc.closest('.main-product__block') || atc.closest('.m-product-form') || atc.parentNode) : document.querySelector('.m-product-info, .m-main-product__info');
    if (!anchor) return;
    anchor.insertAdjacentElement('afterend', box);

    function recalc() {
      var t = 0;
      box.querySelectorAll('input[type=checkbox]').forEach(function (c) { if (c.checked) t += parseInt(c.getAttribute('data-price'), 10) || 0; });
      box.querySelector('.fbt-amount').textContent = money(t);
      box.querySelector('.fbt-add').disabled = t === 0;
    }
    box.addEventListener('change', recalc);
    recalc();

    box.querySelector('.fbt-add').addEventListener('click', function () {
      var btn = this;
      var payload = [];
      box.querySelectorAll('input[type=checkbox]').forEach(function (c) { if (c.checked) payload.push({ id: parseInt(c.getAttribute('data-vid'), 10), quantity: 1 }); });
      if (!payload.length) return;
      btn.disabled = true; btn.textContent = 'Añadiendo…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: payload }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Añadir seleccionados'; });
    });
  }
})();
